module.exports = __webpack_public_path__ + "static/media/expertise-operations-v2.e49c3442.jpg";